import { CustomerAccountStatus } from "@/graphql/codegen/graphql"

export const CUSTOMER_ACCOUNT_STATUS_LABEL_MAP: Record<CustomerAccountStatus, string> = {
  [CustomerAccountStatus.Active]: "Active",
  [CustomerAccountStatus.Inactive]: "Inactive",
  [CustomerAccountStatus.CreditHold]: "Credit Hold",
  [CustomerAccountStatus.Suspended]: "Suspended",
}
